var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatternFive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 313,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-pattern-five_svg__clip0_573_4021)",
    fill: "#F87C56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.942 110.688l-.053-17.493-80.011.245V0L17.673.318C7.938.318 0 8.152 0 17.784v24.585l90.568-.06.052 270.642h17.501l-.056-288.145-90.564.06v-6.96a.35.35 0 01.196-.094l97.68-.256v93.416l97.565-.284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.724 234.405v-17.493H157.387v-81.87a17.554 17.554 0 00-5.146-12.395 17.573 17.573 0 00-12.401-5.144h-24.459v123.854c0 9.506 7.539 17.536 16.468 17.536h157.996l.259 54.124 17.501-.084-.35-71.534h-174.37v-106.42h6.959a.086.086 0 01.045.032v99.394h286.835zM66.004 312.951V49.695h17.5v263.256h-17.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-pattern-five_svg__clip0_573_4021"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(0 1 1 0 0 0)",
    d: "M0 0h313v450H0z"
  })))));
}
export default SvgIconPatternFive;